import { Component, Inject, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatDialogRef, MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Observable, from } from 'rxjs';
import { DialogBase, ConnectLockToObjectInfo, AssetInfo } from 't4core';

@Component({
  styleUrls: ['ConnectLockDialog.css'],
  selector: 'connect-lock',
  templateUrl: 'ConnectLockDialog.html',
})
export class ConnectLockDialog extends DialogBase implements OnInit {
  public deviceType: number = 0;
  public txtLockId = new FormControl('');
  public txtTrackerId = new FormControl('');
  public filteredLocks: Observable<AssetInfo[]>;
  public filteredTrackers: Observable<AssetInfo[]>;
  public isLoading: boolean = false;
  public objectId: number;

  constructor(
    public dialogRef: MatDialogRef<ConnectLockDialog>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    super("ConnectLockDialog");
    this.objectId = this.data.objectId;
  }

  public async ngOnInit() {
    this.txtLockId.valueChanges.subscribe(x => {
      this.filteredLocks = from(this.Api.get<AssetInfo[]>("/RentalObject/FilterAssets", { searchText: x, limit: 50, deviceType: this.deviceType }));
    });
    this.txtTrackerId.valueChanges.subscribe(x => {
      this.filteredTrackers = from(this.Api.get<AssetInfo[]>("/RentalObject/FilterAssets", { searchText: x, limit: 50, deviceType: this.deviceType }));
    });

  }

  public async onTypeChange(value: number) {
    this.deviceType = value;
    if (this.deviceType == 1) {
      this.txtLockId.setValue('');
    }
    else if (this.deviceType == 0) {
      this.txtTrackerId.setValue('');
    }
  }

  public async connect() {
    var ret = await this.connectLock(false);
    if (ret) {
      if (ret.IsSuccess) {
        this.dialogRef.close(true);
      }
      else if (!ret.IsSuccess) {
        if (ret.IsInvalidLock) {
          await this.UI.alert("Turbo.Settings.ConnectLockDialog.headInvalidLock", "Invalid lock", "Turbo.Settings.ConnectLockDialog.msgInvalidLock", "The specified lock id does not exist in T4.");
          return;
        }
        else if (ret.IsInvalidTracker) {
          await this.UI.alert("Turbo.Settings.ConnectLockDialog.InvalidTracker", "Invalid tracker", "Turbo.Settings.ConnectLockDialog.msgInvalidTracker", "The specified tracker does not exist in T4.");
          return;
        }
        else if (ret.LockInUse) {
          var x = await this.UI.confirm("Turbo.Settings.ConnectLockDialog.ConfirmConnection", "Confirm connection", "Turbo.Settings.ConnectLockDialog.LockInUse", "This device is currently assigned to a trailer {0}. Please confirm if you want to re-assign the device. Do you want to continue?", null, [ret.UsedTrailer]);
          if (x) {
            var ret = await this.connectLock(true);
            if (!ret || !ret?.IsSuccess) {
              await this.UI.alert("Turbo.Settings.ConnectLockDialog.headSaveError", "Could not save the changes", "Turbo.Settings.ConnectLockDialog.msgChangeFailedIssues", "There was an error connecting the lock. Please try again later.");
              return;
            }
            else if (ret && ret.IsSuccess) {
              this.dialogRef.close(true);
            }
          }
          else return;
        }
        else if (!ret.IsSuccess) {
          await this.UI.alert("Turbo.Settings.ConnectLockDialog.headSaveError", "Could not save the changes", "Turbo.Settings.ConnectLockDialog.msgChangeFailedIssues", "There was an error connecting the lock. Please try again later.");
          return;
        }
      }
    }
    else {
      await this.UI.alert("Turbo.Settings.ConnectLockDialog.headSaveError", "Could not save the changes", "Turbo.Settings.ConnectLockDialog.msgChangeFailedIssues", "There was an error connecting the lock. Please try again later.");
    }

  }

  private async connectLock(isConfirm: boolean): Promise<ConnectLockToObjectInfo> {
    this.isLoading = true;
    var ret = await this.Api.get<ConnectLockToObjectInfo>("Rental/ConnectLock", { objectId: this.objectId, lockId: this.deviceType == 0 ? this.txtLockId.value : this.txtTrackerId.value, lockType: this.deviceType, isConfirm: isConfirm });
    this.isLoading = false;
    return ret;
  }

  public static async open(dialog: MatDialog, objectId: number) : Promise<Boolean> {
    var dlg = dialog.open(ConnectLockDialog, {
      maxHeight: "calc(100vh - 20px)",
      maxWidth: "calc(100vw - 20px)",
      width: "500px",
      data: {
        objectId: objectId
      }
    });

    return await dlg.afterClosed().toPromise();
  }
}
